import { Pass } from 'three/examples/jsm/postprocessing/Pass.js';

/**
 * Composites the first-person viewmodel scene on top of the already-rendered
 * world, with the depth buffer cleared so the gun can never be occluded by
 * geometry it is standing inside.
 *
 * This exists instead of `RenderPass { clear:false, clearDepth:true }` because
 * three's RenderPass calls `renderer.clearDepth()` *before* it binds its target
 * — so it clears whatever framebuffer the previous pass happened to leave bound.
 * That is harmless when the viewmodel pass immediately follows the world pass,
 * and silently wrong the moment anything (AO, motion blur) sits between them,
 * which is exactly our graph. Binding first and clearing second is the fix.
 */
export class ViewmodelPass extends Pass {
  constructor(scene, camera) {
    super();
    this.scene = scene;
    this.camera = camera;
    this.needsSwap = false; // draws into readBuffer, in place
  }

  render(renderer, writeBuffer, readBuffer) {
    const oldAutoClear = renderer.autoClear;
    renderer.autoClear = false;

    renderer.setRenderTarget(this.renderToScreen ? null : readBuffer);
    renderer.clearDepth();
    renderer.render(this.scene, this.camera);

    renderer.autoClear = oldAutoClear;
  }
}
